import * as React from 'react';
import * as Sebrae from '@sebrae/react-core';
import { BaSeHeader, BaSeParagraph, BaSeTheme } from '@base/react';
import { Role } from '../../models/role';

const menuItens = (click) => [
  {
    onClick: () => click('/certificados'),
    label: 'Meus certificados',
  },
  {
    onClick: () => click('/'),
    label: 'Validar certificados',
  },
  {
    onClick: () =>
      click('https://www.sebrae.com.br/sites/PortalSebrae/faleconosco'),
    label: 'Fale conosco',
  },
  {
    onClick: () =>
      click('/abertura-chamado'),
    label: 'Ajuda',
  },
];

// eslint-disable-next-line sonarjs/cognitive-complexity
export const LayoutHeader = ({ name }) => {
  const { navigateTo } = Sebrae.useRouter();
  const { keycloak, hasRole, hasRoles } = Sebrae.useAuth();

  const leftHeader = () => {
    return (
      <div style={{ flex: 1, fontSize: 23 }}>
        <BaSeParagraph isBold color={BaSeTheme.colors.defaultColors.white}>
          {name}
        </BaSeParagraph>
      </div>
    );
  };

  const handleRole = (role) => hasRole(Role.Administrador) || hasRole(role?.toUpperCase());

  return (
    <div>
      <BaSeHeader
        menuItens={menuItens(navigateTo)}
        systemName={name}
        accountProfileProps={{
          keycloak,
          contextLinks: [
            hasRoles([
              Role.Administrador,
              Role.GestorNacional,
              Role.GestorUF,
            ]) && {
              label: 'Certificados do cliente',
              url: '/certificados-cliente',
            },
            hasRoles([
              Role.Administrador,
              Role.GestorNacional,
            ]) && {
              label: 'Gerar certificados em lote',
              url: '/gerar-certificados-lote',
            },
            handleRole(Role.Administrador) && {
              label: 'Templates de certificados',
              url: '/templates-certificados',
            },
          ].filter((ele) => !!ele),
        }}
        logoOnClick={() => navigateTo(`/`)}
        collapsedBreakpoint="onMobileLarge"
        delimitedOnBreakpoint="desktop"
        customComponents={[
          {
            component: leftHeader,
            showOnExpanded: true,
            showOnCollapsed: false,
            showOnSidebar: false,
          },
        ]}
      />
    </div>
  );
};
